<template>
	<div class="home">
		<van-popup v-model="detailShow" get-container="body" :style="{ height: '95%', width: '95%' }" :closeable="true">
			<div class="">
				<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
					详情
				</div>
				<van-cell-group class="plr20">
					<van-cell title="气瓶编号" :value="bottledetail.bottleId || '-'" />
					<van-cell title="登记单位" :value="bottledetail.ownerDeptName || '-'" />
					<van-cell title="充装介质" :value="bottledetail.gasTypeName || '-'" />
					<van-cell title="下检年月" :value="bottledetail.nextCheckDate || '-'" />
					<van-cell title="入库时间" :value="bottledetail.incomingTime || '-'" />
					<van-cell title="入库责任人" :value="bottledetail.incomingName || '-'" />
					<div v-if="bottledetail.stockStatus == 2 || bottledetail.stockStatus == 4">
						<van-cell title="领用单位" :value="bottledetail.sysDeptName || '-'" />
						<van-cell title="领用时间" :value="bottledetail.borrowDate || '-'" />
						<van-cell title="领用责任人" :value="bottledetail.borrowerName || '-'" />
					</div>					
					<div v-if="bottledetail.stockStatus == 4">
						<van-cell title="归还时间" :value="bottledetail.returnTime || '-'" />					
						<van-cell title="归还责任人" :value="bottledetail.returnAuditer || '-'" />
					</div>											
				</van-cell-group>

				<div class="tc ptb10">
					<van-button type="danger" class="tc" @click="detailShow = false">关闭</van-button>
				</div>
			</div>
		</van-popup>
		<div class="top">
			<div class="homes">
				<van-tabs v-model="active" @click="initContent" color="#4597ff">
					<van-tab title="领用查询">
						<div class="chaxun">
							<div class="">
								<van-popup v-model="showSysDept" round position="bottom">
									<van-cascader v-model="cascaderValue" title="请选择领用部门" :options="sysDeptsOptions" @close="showSysDept = false"
										@change="onSysDeptChange" @finish="onSysDeptFinish" />
								</van-popup>
								<van-form ref="appForm" @failed="failed" validate-trigger="onSubmit"
									label-align="center" :scroll-to-error="true" :validate-first="true">

									<van-field v-model="appForm.borrowDeptName" name="领用部门" label="领用部门" placeholder="请选择领用部门"
										@click="getSysDepart()" readonly is-link />									

									<van-field v-model="appForm.gasType" name="填充介质" label="填充介质" placeholder="请选择填充介质"
										@click="openPicker1('gasTypeNoDept')" readonly is-link />
									
									<van-popup v-model="showPicker" round position="bottom" get-container="#app">
										<van-picker title="请选择" item-height="7vh" show-toolbar :columns="columns"
											@confirm="pickerConfirm" @cancel="pickerCancel" />
									</van-popup>
									<div class="flex w100 alcenter between">
										<van-button class="w48" style="border-right: 3px solid #fff" type="primary" native-type="button"
											@click="queryStock(true)" block>查询</van-button>
										<van-button class="w48" style="border-right: 3px solid #fff" square
											@click="reset" block type="info" native-type="button">重置</van-button>
									</div>
								</van-form>
								<div class="totalDiv">
									<span>总数：{{ borrowList.length }}</span>
								</div>
								<div class="bggrey show-list">
									<van-list v-model="isLoading" :finished="finishedBottom" finished-text="没有更多了"
										@load="onLoad">
										<div v-for="(item, index) in borrowList" :key="index"
											style="margin-top: 20px; padding: 0">
											<div class="main">
												<div class="history-left" style="margin-top: 20px;">
													<div class="history-item">
														<span>气瓶编号：</span>
														<span>{{ item.bottleId }}</span>
													</div>
													<div class="history-item">
														<span>厂家：</span>
														<span>{{ item.ownerDeptName }}</span>
													</div>
													<div class="history-item">
														<span>气体类型：</span>
														<span>{{ item.gasTypeName }}</span>
													</div>													
													<div class="history-item">
														<span>下检时间：</span>
														<span>{{ item.nextCheckDate }}</span>
													</div>
													<div class="history-item">
														<div v-if="item.stockStatus == 1">
															<span>入库时间：</span>
															<span>{{ item.incomingTime }}</span>
														</div>
														<div v-else-if="item.stockStatus == 2">
															<span>领用时间：</span>
															<span>{{ item.borrowDate }}</span>
														</div>
														<div v-else-if="item.stockStatus == 4">
															<span>归还时间：</span>
															<span>{{ item.returnTime }}</span>
														</div>

													</div>
													<div class="history-item">
														<span>责任人：</span>
														<span>{{ item.responsiblePerson }}</span>
													</div>
												</div>
												<van-button plain type="primary" size="small" class="userBtn1"
													@click="getDetailList(item.id)">详情
												</van-button>
											</div>
										</div>
									</van-list>
								</div>
							</div>
						</div>
					</van-tab>
					<van-tab title="明细查询">
						<div class="chaxun">
							<div class="">
								<van-form ref="appForm" @failed="failed" validate-trigger="onSubmit"
									label-align="center" :scroll-to-error="true" :validate-first="true">

									<van-field v-model="appForm.ownerDept" name="厂家" label="厂家" placeholder="请选择厂家"
										@click="openPicker1('ownerDept')" readonly is-link />

									<van-field v-model="appForm.gasType" name="气体类型" label="气体类型" placeholder="请选择气体类型"
										@click="openPicker1('gasType')" readonly is-link />

									<!-- <van-field v-model="appForm.bottleStatus" name="气瓶状态" label="气瓶状态"
										placeholder="请选择气瓶状态" @click="openPicker1('bottleStatus')" readonly is-link>										
									</van-field> -->
									<van-field v-model="appForm.stockStatus" name="库存状态" label="库存状态"
										placeholder="请选择库存状态" @click="openPicker1('stockStatus')" readonly is-link>
									</van-field>
									<div class="flex alcenter between">
										<van-field v-model="appForm.bottleId" name="气瓶编号" label="气瓶编号"
											placeholder="请输入气瓶编号">
										</van-field>
										<div class="saoma" @click="scanQRcode">扫码</div>
									</div>
									<van-popup v-model="showPicker" round position="bottom" get-container="#app">
										<van-picker title="请选择" item-height="7vh" show-toolbar :columns="columns"
											@confirm="pickerConfirm" @cancel="pickerCancel" />
									</van-popup>
									<div class="flex w100 alcenter between">
										<van-button class="w48" style="border-right: 3px solid #fff" type="primary" native-type="button"
											@click="queryStock(false)" block>查询</van-button>
										<van-button class="w48" style="border-right: 3px solid #fff" square
											@click="reset" block type="info" native-type="button">重置</van-button>
									</div>
								</van-form>
								<div class="totalDiv">
									<span>总数：{{ stockList.length }}</span>
								</div>
								<div class="bggrey show-list">
									<van-list v-model="isLoading" :finished="finishedBottom" finished-text="没有更多了"
										@load="onLoad">
										<div v-for="(item, index) in stockList" :key="index"
											style="margin-top: 20px; padding: 0">
											<div class="main">
												<div class="history-left" style="margin-top: 20px;">
													<div class="history-item">
														<span>气瓶编号：</span>
														<span>{{ item.bottleId }}</span>
													</div>
													<div class="history-item">
														<span>厂家：</span>
														<span>{{ item.ownerDeptName }}</span>
													</div>
													<div class="history-item">
														<span>气体类型：</span>
														<span>{{ item.gasTypeName }}</span>
													</div>													
													<div class="history-item">
														<span>下检时间：</span>
														<span>{{ item.nextCheckDate }}</span>
													</div>
													<div class="history-item">
														<div v-if="item.stockStatus == 1">
															<span>入库时间：</span>
															<span>{{ item.incomingTime }}</span>
														</div>
														<div v-else-if="item.stockStatus == 2">
															<span>领用时间：</span>
															<span>{{ item.borrowDate }}</span>
														</div>
														<div v-else-if="item.stockStatus == 4">
															<span>归还时间：</span>
															<span>{{ item.returnTime }}</span>
														</div>

													</div>
													<div class="history-item">
														<span>责任人：</span>
														<span>{{ item.responsiblePerson }}</span>
													</div>
												</div>
												<van-button plain type="primary" size="small" class="userBtn1"
													@click="getDetailList(item.id)">详情
												</van-button>
											</div>
										</div>
									</van-list>
								</div>
							</div>
						</div>
					</van-tab>
					<van-tab title="汇总">
						<div class="autoFixed">
							<van-list v-model="isLoading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
								<div v-for="(item, index) in stockcollectList" :key="index"
									style="margin-top: 20px; padding: 0">
									<div class="main">
										<div class="history-left" style="margin-top: 20px;">
											<div class="history-item">
												<span>气体类型：</span>
												<span>{{ item.gasName }}</span>
											</div>
											<div class="history-item">
												<span>库存总数：</span>
												<span>{{ item.stockTotal }}</span>
											</div>
											<div class="history-item">
												<span>领用总数：</span>
												<span>{{ item.borrowTotal }}</span>
											</div>
											<div class="history-item">
												<span>剩余总数：</span>
												<span>{{ item.leftTotal }}</span>
											</div>
											<div class="history-item">
												<span>空瓶总数：</span>
												<span>{{ item.emptyTotal }}</span>
											</div>

										</div>
									</div>
								</div>
							</van-list>
						</div>
					</van-tab>
				</van-tabs>
			</div>

		</div>
	</div>
</template>
<script>
import tabs from "@/components/tabs.vue";
import {
	stockcollect,
	ownerDeptList,
	queryBottleStatusList,
	stockQueryList,
	getBottleTypes,//查询气瓶填充介质
	getDepartments,//获取部门列表
	bottleStockflow,
	getJsApi,
	parseQrcode
} from "@/apis/api";
import {
	Toast,
	Dialog,
	ImagePreview,
} from "vant";

export default {
	data() {
		return {
			stockList: [],
			borrowList:[],
			stockcollectList: [
				{
					borrowTotal: 0,
					emptyTotal: 0,
					gasName: "string",
					leftTotal: 0,
					stockTotal: 0
				}
			],
			pageNo: 1,
			pageSize: 10,
			total: 0,
			isLoading: false,
			//loading: false,
			finishedBottom: false,
			active: 0,
			currentDate: new Date(),
			showForm: {},
			healthCodeList: [],
			sysDeptsOptions:[],//下拉选择的部门
      		cascaderValue:"",
      		showSysDept:false,
			appForm: {
				bottleId: "",
				bottleStatus: "",
				stockStatus: "",
				gasType: "",
				ownerDept: "",
				borrowDeptName:""
			},
			appFormParams: {
				bottleId: "",
				bottleStatus: "",
				stockStatus: "",
				gasType: "",
				ownerDept: "",				
				borrowDept:""
			},
			leaveLoc: '',
			proposerType: '',
			picker_car: '',
			show: false,
			detailShow: false,
			bottledetail: {},
			nishow: false,
			showPicker: false,
			showCalendar: false,
			columns: [],
			gasTypeColumns: [],
			ownerDeptList: [],
			picker_v: 1,
		};
	},
	mounted() {
		document.title = "库存查询";
		this.getSystemConfig();
	},
	methods: {
		reset() {			
      		this.cascaderValue="",
      		this.showSysDept=false,
			this.appForm={
				bottleId: "",
				bottleStatus: "",
				stockStatus: "",
				gasType: "",
				ownerDept: "",
				borrowDeptName:""
			},
			this.appFormParams= {
				bottleId: "",
				bottleStatus: "",
				stockStatus: "",
				gasType: "",
				ownerDept: "",
				borrowDept:""
			},
			this.stockList=[]
			this.borrowList=[]
		},
		// 获取历史列表
		getDetailList(bottleId) {
			this.detailShow = true;
			bottleStockflow({
				bottleId: bottleId
			}).then(res => {
				if (res.code == 200) {
					this.bottledetail = res.result;
				} else {
					this.$toast(res.message);
				}
			})
		},
		openPicker1(code) {
			if (code === 'gasType') {
				const ownerDeptId = this.appFormParams.ownerDept;
				if (ownerDeptId === '') {
					this.$toast("请选择气瓶厂家");
					this.columns = [];
					return;
				} else if (this.ownerDeptList.length === 0) {
					this.columns = [];
					this.$toast("气瓶厂家没有气体类型");
					return;
				}
			}
			if (this.picker_car !== code)
				this.getSysCategory(code);
			this.picker_car = code
			this.showPicker = true;
		},
		// picker弹窗确定
		pickerConfirm(e) {
			console.log(e);
			if (this.picker_car === "ownerDept") {
				this.appForm.ownerDept = e.text;
				this.appFormParams.ownerDept = e.value;
			} else if (this.picker_car === "gasType" || this.picker_car ==='gasTypeNoDept') {
				this.appForm.gasType = e.text;
				this.appFormParams.gasType = e.value;
			} else if (this.picker_car === "bottleStatus") {
				this.appForm.bottleStatus = e.text;
				this.appFormParams.bottleStatus = e.value;
			}
			else if (this.picker_car === "stockStatus") {
				this.appForm.stockStatus = e.text;
				this.appFormParams.stockStatus = e.value;
			}			
			this.showPicker = false;
		},
		pickerCancel() {
			this.showPicker = false;
		},
		// 获取picker数据
		getSysCategory(code, keyWord = '') {
			let data = {
			}
			if (code === 'ownerDept') {
				ownerDeptList(data).then((res) => {
					if (res.code === 200) {
						if (res.result.length) {
							res.result.forEach((i, v) => {
								i.text = i.deptName;
								i.value = i.id;
							})
						}
						this.columns = res.result;
						this.ownerDeptList = res.result;
					} else {
						this.$toast(res.message);
					}
				});
			} else if (code === 'gasType') {
				const ownerDeptId = this.appFormParams.ownerDept;
				for (let i = 0; i < this.ownerDeptList.length; i++) {
					if (this.ownerDeptList[i].id === ownerDeptId) {
						const gasTypeArray = [];
						this.ownerDeptList[i].gasInfos.forEach((i, v) => {
							gasTypeArray.push({ value: i.id, text: i.name })
						})
						this.columns = gasTypeArray;
						break;
					}
				}
			}else if(code==='gasTypeNoDept'){
				getBottleTypes().then((res) => {					
					if (res.code === 200) {
						if (res.result.length) {
							res.result.forEach((i, v) => {
								i.text = i.name;
								i.value = i.id;
							})
							this.columns = res.result;
						}
					} else {
						this.$toast(res.message);
					}
				});
			} else if (code === 'bottleStatus') {
				queryBottleStatusList(data).then((res) => {
					if (res.code === 200) {
						if (res.result.length) {
							res.result.forEach((i, v) => {
								i.text = i.name;
								i.value = i.id;
							})
						}
						this.columns = res.result;
					} else {
						this.$toast(res.message);
					}
				});
			}
			else if (code === 'stockStatus') {
				this.columns = [];
				this.columns.push({ value: 1, text: '入库' });
				this.columns.push({ value: 2, text: '领用' });
				this.columns.push({ value: 4, text: '归还' });
			}
		},

		/**
		 * 库存查询，
		 * @param {boolean} borrowFlag 是否为领用查询
		 */
		queryStock(borrowFlag) {
			this.pageNo = 1;
			this.pageSize = 10;
			this.isLoading = true;
			//如果是领用则只查询领用的记录
			this.appFormParams.stockStatus = borrowFlag ? 2 : this.appFormParams.stockStatus;
			this.appFormParams.bottleId = ((this.appForm.bottleId || '').trim()) || undefined;
			// 配合请求前过滤undefined字段！
			stockQueryList({
				pageNo: this.pageNo,
				pageSize: this.pageSize,
			}, this.appFormParams).then((res) => {
				this.isLoading = false;
				//this.loading = false;
				if (res.code === 200) {
					if(borrowFlag)
					{
						this.borrowList = res.result;
					}
					else
					{
						this.stockList = res.result;
					}					
					this.finishedBottom = true;
				} else {
					this.finishedBottom = true;
				}
			});
		},
		cancel() {
			this.showCalendar = false;
		},
		// 校验失败
		failed() {
			console.log(111);
		},

		// 获取历史
		getStockList() {
			this.onRefresh(1)
		},
		onRefresh(index) {
			this.pageNo = 1;
			this.pageSize = 10;
			this.isLoading = true;
			stockcollect({
			}).then((res) => {
				this.isLoading = false;
				//this.loading = false;
				if (res.code === 200) {
					if (index !== 1) {
						Toast("刷新成功");
					}
					this.stockcollectList = res.result;
					this.finishedBottom = true;
				} else {
					this.finishedBottom = true;
				}
			});
		},
		onLoad() {
			console.log("加载更多");
			if (this.isLoading) return
			this.pageNo++;
			stockQueryList({
				pageNo: this.pageNo,
				pageSize: this.pageSize,
			}).then((res) => {
				this.isLoading = false;
				//this.loading = false;
				if (res.code == 200) {
					this.historyList = this.historyList.concat(res.result.records);
					if (this.historyList.length == this.total) {
						this.finishedBottom = true;
					}
				} else {
					this.finishedBottom = true;
				}
			});
		},
		initContent(value) {
			this.active = value;
			if (value === 0) {
				// 刷新页面
			} else {
				this.pageSize = 10;
				this.pageNo = 1;
				this.getStockList();
			}
		},

		//--------------------------------------------
		// 扫码配置
		getSystemConfig() {
			getJsApi({ curUrl: encodeURI(location.href.split("#")[0]) })
				.then((res) => {
					if (res.code == 200) {
						let configs = res.result;
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: configs.appId, // 必填，公众号的唯一标识
							timestamp: configs.timestamp, // 必填，生成签名的时间戳
							nonceStr: configs.nonceStr, // 必填，生成签名的随机串
							signature: configs.signature, // 必填，签名
							jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
						});
						wx.ready((res) => {
							console.log("配置完成，扫码前准备完成");
						});
						wx.error(function (res) {
							console.log("出错了：" + res.errMsg);
						});
					} else {
						this.$toast(res.message);
					}
				})
				.catch((err) => { });
		},
		//扫码
		scanQRcode: function () {
			var ua = navigator.userAgent.toLowerCase();
			var isWeixin = ua.indexOf("micromessenger") !== -1;
			if (!isWeixin) {
				alert("请用微信打开连接，才可使用扫一扫");
			}
			wx.scanQRCode({
				needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，				
				scanType: ["qrCode"], // 二维码
				success: (res) => {
					console.log(res);
					if (res.resultStr.length > 0) {
						//气瓶二维码
						//alert("扫描成功"+res.resultStr);
						this.getBottleId(res.resultStr);
					}
				},
				fail: (err) => {
					console.log(err);
				},
			});
		},
		//查询气瓶id信息
		getBottleId(resultStr) {
			parseQrcode({
				qrcode: resultStr
			}).then(res => {
				if (res.code == 200) {
					let result = res.result;
					this.appForm.bottleId = result.bottleId;
					this.appFormParams.bottleId = result.bottleId;
				} else {
					this.$toast(res.message);
				}
			})
		},

		//部门选择
		getSysDepart() {
				this.showSysDept = true;
				getDepartments().then((res) => {
					console.log(res);
					this.sysDeptsOptions = res.result.map((item) => {
						item.text = item.departName;
						item.value = item.id;
						//只取第一级部门
						// if( item.departList.length>0){
						// 	item.children = item.departList;
						// 	item.children.forEach(iitem => {
						// 		iitem.text = iitem.departName
						// 		iitem.value = iitem.id;
						// 	})
						// }						
						return item;
					});
				});
			},

      onSysDeptChange({
				value
			}) {

			},
			onSysDeptFinish({
				selectedOptions
			}) {
				this.showSysDept = false;
				//显示部门名称
				this.appForm.borrowDeptName = selectedOptions.map((option) => option.text).join("/");				
				//查询的时候用部门id
				this.appFormParams.borrowDept = selectedOptions.pop().value;
        console.info("选择的部门："+this.appForm.borrowDeptName+",部门id:"+this.appFormParams.borrowDept);
			},

	},
	components: {
		tabs,
	},
};
</script>

<style lang="less" scoped>
body {
	height: 100%;
	background: #f3f3f3;
}

.homes {
	border-top: 1px solid #ccc;
	width: 100%;
	height: 100%;
}

.totalDiv{
	height: 50px;
	line-height: 50px;
	span {
		font-size: 28px;
		color: #ee0a0a;
		margin-left: 40px;
	}
}

.modals {
	position: relative;
	height: 100%;
	padding-bottom: 7vh !important;

}

.chaxun {
	min-height: 95vh;
	background-color: #ffffff;

	.show-list {
		background: #f3f3f3;
		min-height: 60vh;
		padding: 10px 20px;
		position: relative;
	}
}

.autoFixed {
	background: #f3f3f3;
	min-height: 100vh;
	padding: 10px 20px;
	position: relative;


}


.saoma {
	background-color: #4597ff;
	color: #fff;
	height: 6.5vh;
	line-height: 6.5vh;
	text-align: center;
	width: 18vw;
}

.main {
	box-sizing: content-box;
	background: #ffffff;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	width: 100%;
	border-radius: 5px;
	padding: 0 24px;
	box-sizing: border-box;
	position: relative;


	.history-item {
		height: 50px;
		line-height: 50px;

		span {
			font-size: 28px;
			color: #333;
		}
	}

	.userBtn1 {
		position: absolute;
		right: 20px;
		top: 25px;
		width: 94px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: none;
		border-radius: 5px;
		color: #55aa7f;
	}
}
</style>
